import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';

import { ThemeContext } from '../../contexts/ThemeContext';
// import altenn from '../../assets/svg/experience/expImgWhite.svg'
import expImgWhite from '../../assets/svg/experience/expImgWhite.svg'
import expImgBlack from '../../assets/svg/experience/expImgBlack.svg'

import './Experience.css'

function ExperienceCard({id, company, jobtitle, startYear, endYear}) {

    const { theme } = useContext(ThemeContext);

    const useStyles = makeStyles((t) => ({
        experienceCard : {
            backgroundColor:theme.primary30,
            "&:hover": {
                backgroundColor:theme.primary50,
            },
        },
    }));

    const classes = useStyles();


    return (
        <Fade bottom>
            <div key={id} className={`experience-card ${classes.experienceCard}`}>
                <div className="expcard-img" >
                    {company === 'Monaco Telecom'&&<img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxG7Q6GthsptVAmmq-A0K36dmkPw1oOPytUA&s' alt="" />}
                    {company === 'ALTEN'&&<img src='https://upload.wikimedia.org/wikipedia/fr/8/82/Logo_ALTEN.jpg' alt="" />}
                    {company === 'SQUAD'&&<img src='https://media.licdn.com/dms/image/v2/D4E0BAQHGO6J2c7FlGw/company-logo_200_200/company-logo_200_200/0/1665399844820/squad_conseil_logo?e=2147483647&v=beta&t=bJHTK2KvOI_urusooO5Mz8UWcYMPyikdn_k6vY91a-c' alt="" />}
                    {/* <img src={theme.type === 'light' ? expImgBlack : expImgWhite} alt="" /> */}
                </div>
                <div className="experience-details">
                    <h6 style={{color: theme.primary}}>{startYear}-{endYear}</h6>
                    <h4 style={{color: theme.tertiary}}>{jobtitle}</h4>
                    <h5 style={{color: theme.tertiary80}}>{company}</h5>
                </div>
            </div>
        </Fade>   
    )
}

export default ExperienceCard
